// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2U5Os","head":"Table_head__3E1-X","col":"Table_col__33mfo"};